export const iaaiEnvironmentalFee = 15.00;
export const iaaiServiceFee = 105.00; // effective Oct 1, 2026
export const iaaiTitleFee = 20.00;
